import { FC, MouseEvent, ChangeEvent, CSSProperties } from 'react';
import { TablePagination, TablePaginationProps } from '@material-ui/core';

export interface CountlessOptions {
  hasNextPage: () => boolean;
  hasPrevPage: () => boolean;
}

type LabelDisplayedRows = TablePaginationProps['labelDisplayedRows'];

export interface WbPaginationProps {
  rowsPerPageOptions?: Array<number>;
  countlessOptions?: CountlessOptions;
  count: number;
  limit: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  style?: CSSProperties;
  currentPage?: number;
  offset?: number;
  labelDisplayedRows?: LabelDisplayedRows;
}

export const WbPagination: FC<WbPaginationProps> = ({
  rowsPerPageOptions,
  count,
  limit,
  onPageChange,
  onRowsPerPageChange,
  countlessOptions,
  labelDisplayedRows,
  currentPage,
  offset,
  style,
}) => {
  const handleChangePage = (
    _event: MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    onRowsPerPageChange(parseInt(event.target.value, 10));
  };

  const getPage = () => {
    if (currentPage) return currentPage;
    if (offset) return Math.floor(offset / limit);

    return 0;
  };

  const labelDisplayedRowsInner: LabelDisplayedRows =
    labelDisplayedRows ??
    (countlessOptions ? ({ from, to }) => `${from}-${to}` : undefined);

  return (
    !!count && (
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions || [25, 50, 75, 100, 200]}
        component="div"
        count={count}
        labelDisplayedRows={labelDisplayedRowsInner}
        nextIconButtonProps={
          countlessOptions
            ? {
                disabled: !countlessOptions.hasNextPage(),
              }
            : undefined
        }
        backIconButtonProps={
          countlessOptions
            ? {
                disabled: !countlessOptions.hasPrevPage(),
              }
            : undefined
        }
        rowsPerPage={limit}
        page={getPage()}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        style={{ alignSelf: 'flex-end', ...style }}
      />
    )
  );
};
